import { Row, Select, Skeleton } from 'antd';
import CardSection from '../../../components/section/CardSection';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchAuthorizedAPIEndpoint } from '../../../utils';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectModel, setModel } from '../../../features/analysisConfig/analysisConfigSlice';
import { FeatureFlag, UserClaimsWithTSDB } from '../../../types/userType';
import { ModelMetadata } from '../../../types/analysisTypes';

type DashboardModelProps = {};

const DashboardModel: React.FC<DashboardModelProps> = () => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | undefined>();
  const [models, setModels] = useState<ModelMetadata[]>([]);
  const [selectedModel, setSelectedModel] = useState<string>();
  const model = useAppSelector(selectModel);
  const { sessionID } = useParams<{ sessionID: string }>();
  const [userInfo, setUserInfo] = useState<UserClaimsWithTSDB | null>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      setAccessToken(token);
    });
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (!user || !isAuthenticated) setUserInfo(null);
    else setUserInfo(user as UserClaimsWithTSDB);
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (!accessToken) return;

    fetchAuthorizedAPIEndpoint(`/compare/list_models?session_id=${sessionID}`, accessToken)
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        } else {
          throw new Error();
        }
      })
      .then((models: { ModelsMetadata: ModelMetadata[] }) => {
        if (!models) return;

        setModels(models.ModelsMetadata);
        if ((!model || model.Label === '') && models.ModelsMetadata[0]) {
          dispatch(setModel(models.ModelsMetadata[0]));
          setSelectedModel(models.ModelsMetadata[0].Name);
        }
        console.log(model);
      });
  }, [accessToken, sessionID, userInfo]);

  useEffect(() => {
    if (!selectedModel) return;
    const model = models.find((m) => m.Name === selectedModel);

    if (model) dispatch(setModel(model));
  }, [selectedModel]);

  return (
    <>
      {model && (
        <CardSection scroll="auto" marginBottom="2%" minHeight="100px">
          <Row justify="space-between" style={{ marginTop: -10 }}>
            <p style={{ fontWeight: 500, marginBottom: 10 }}>Quality control method</p>
          </Row>
          <div>
            <Select
              value={model.Label}
              style={{ width: '100%' }}
              disabled={userInfo === null || userInfo.feature_flags.includes(FeatureFlag.AALightViewQualityControl)}
              showSearch={true}
              placeholder="Select a model"
              allowClear={false}
              options={models.map((m) => {
                return {
                  key: m.Name,
                  label: m.Label,
                  value: m.Name,
                };
              })}
              onChange={(m) => {
                setSelectedModel(m);
              }}
            />
          </div>
        </CardSection>
      )}
    </>
  );
};

export default DashboardModel;
